import { render, staticRenderFns } from "./MenuNavigationExternalUser.vue?vue&type=template&id=d8afaeea&scoped=true"
import script from "./MenuNavigationExternalUser.vue?vue&type=script&lang=js"
export * from "./MenuNavigationExternalUser.vue?vue&type=script&lang=js"
import style0 from "./MenuNavigationExternalUser.vue?vue&type=style&index=0&id=d8afaeea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8afaeea",
  null
  
)

export default component.exports